module.exports = "../fonts/HelveticaNeueLTW01-55Roman.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-55Roman.ttf
// module id = m07I
// module chunks = 1